module.exports = __webpack_public_path__ + "static/media/fancy_grade_Diamonds.f6581daf.jpg";